import { render, staticRenderFns } from "./SuitAddDialog.vue?vue&type=template&id=6825f07e"
import script from "./SuitAddDialog.vue?vue&type=script&lang=js"
export * from "./SuitAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports